import { bindable, autoinject } from 'aurelia-framework';
import { DOM } from 'aurelia-pal';
import { I18N } from 'aurelia-i18n';
import $ from 'jquery';
import numeral from 'numeral';
import * as moment from 'moment';
import { PayrazrService } from '../../services/payrazr';
import {
	PortalTemplateTypes,
	PortalTemplateTypesNames,
	ApplyTemplateBaseRequest,
	ApplyCardSinglePaymentTemplateRequest,
	ApplyCheckSinglePaymentTemplateRequest,
	ApplyCardInstallmentPlanReceiptTemplateRequest,
	ApplyCheckInstallmentPlanReceiptTemplateRequest,
	ApplyCardRecurringPlanReceiptTemplateRequest,
	ApplyCheckRecurringPlanReceiptTemplateRequest,
	ApplyAutopayPlanReceiptTemplateRequest,
	TemplateService,
	ApplyTransactionFailedTemplateRequest
} from '../../services/template-service';
import { ServiceResponse } from '../../models/service-response';
import { ICustomerAccountToPay } from '../../services/hpf-transaction-service';

@autoinject
export class Receipt {
	@bindable customMessage: string = '';
	@bindable customerAccountNumber: string = '';
	@bindable isPaymentPlanReceipt: boolean = false;
	@bindable receiptType: PortalTemplateTypes;
	@bindable planId: string = '';
	@bindable pnref: number;
	@bindable merchantKey: number;
	@bindable savedPaymentMethodToWallet: boolean = null;
	@bindable resultCode: string = '';
	@bindable resultMessage: string = '';
	@bindable autopayKey: number;
	@bindable bucketKey: number = null;
	@bindable accountPayments: ICustomerAccountToPay[] = null;
	@bindable enableEditTransaction: boolean = false;
	@bindable isEzpay: boolean = false;
	content: any;
	editTransactionClickCount: number = 0;
	applyTemplateRequest: any;
	hasScheduledInReceipt: boolean = false;

	constructor(private element: Element, private payrazrService: PayrazrService, private templateService: TemplateService, private i18n: I18N) {
	}

	reset() {
		this.customMessage = '';
		this.customerAccountNumber = '';
		this.resultCode = '';
		this.resultMessage = '';
		this.accountPayments = null;
		this.content = '';
	}

	buildTemplateRequestAndCallApplyTemplate() {
		switch (this.receiptType) {
			case PortalTemplateTypes.CreditCardSinglePaymentReceipt:
				this.applyTemplateRequest = new ApplyCardSinglePaymentTemplateRequest();
				this.applyTemplateRequest.pnref = this.pnref;
				this.applyTemplateRequest.savedPaymentMethodToWallet = this.savedPaymentMethodToWallet;
				this.applyTemplateRequest.accountPayments = this.accountPayments;
				this.applyTemplateRequest.isEzpay = this.isEzpay;
				break;
			case PortalTemplateTypes.CheckSinglePaymentReceipt:
				this.applyTemplateRequest = new ApplyCheckSinglePaymentTemplateRequest();
				this.applyTemplateRequest.pnref = this.pnref;
				this.applyTemplateRequest.savedPaymentMethodToWallet = this.savedPaymentMethodToWallet;
				this.applyTemplateRequest.accountPayments = this.accountPayments;
				this.applyTemplateRequest.isEzpay = this.isEzpay;
				break;
			case PortalTemplateTypes.CreditCardInstallmentPlanReceipt:
				this.applyTemplateRequest = new ApplyCardInstallmentPlanReceiptTemplateRequest();
				this.applyTemplateRequest.planId = this.planId;
				this.applyTemplateRequest.merchantKey = this.merchantKey;
				this.applyTemplateRequest.savedPaymentMethodToWallet = this.savedPaymentMethodToWallet;
				this.applyTemplateRequest.accountPayments = this.accountPayments;
				this.applyTemplateRequest.isEzpay = this.isEzpay;
				break;
			case PortalTemplateTypes.CheckInstallmentPlanReceipt:
				this.applyTemplateRequest = new ApplyCheckInstallmentPlanReceiptTemplateRequest();
				this.applyTemplateRequest.planId = this.planId;
				this.applyTemplateRequest.merchantKey = this.merchantKey;
				this.applyTemplateRequest.savedPaymentMethodToWallet = this.savedPaymentMethodToWallet;
				this.applyTemplateRequest.accountPayments = this.accountPayments;
				this.applyTemplateRequest.isEzpay = this.isEzpay;
				break;
			case PortalTemplateTypes.CreditCardRecurringPaymentPlanReceipt:
				this.applyTemplateRequest = new ApplyCardRecurringPlanReceiptTemplateRequest();
				this.applyTemplateRequest.planId = this.planId;
				this.applyTemplateRequest.merchantKey = this.merchantKey;
				this.applyTemplateRequest.savedPaymentMethodToWallet = this.savedPaymentMethodToWallet;
				this.applyTemplateRequest.isEzpay = this.isEzpay;
				break;
			case PortalTemplateTypes.CheckRecurringPaymentPlanReceipt:
				this.applyTemplateRequest = new ApplyCheckRecurringPlanReceiptTemplateRequest();
				this.applyTemplateRequest.planId = this.planId;
				this.applyTemplateRequest.merchantKey = this.merchantKey;
				this.applyTemplateRequest.savedPaymentMethodToWallet = this.savedPaymentMethodToWallet;
				this.applyTemplateRequest.isEzpay = this.isEzpay;
				break;
			case PortalTemplateTypes.AutopayPlanReceipt:
				this.applyTemplateRequest = new ApplyAutopayPlanReceiptTemplateRequest();
				this.applyTemplateRequest.autopayKey = this.autopayKey;
				this.applyTemplateRequest.merchantKey = this.merchantKey;
				this.applyTemplateRequest.savedPaymentMethodToWallet = this.savedPaymentMethodToWallet;
				this.applyTemplateRequest.isEzpay = this.isEzpay;
				break;
			case PortalTemplateTypes.TransactionFailed:
				this.applyTemplateRequest = new ApplyTransactionFailedTemplateRequest();
				this.applyTemplateRequest.resultCode = this.resultCode;
				this.applyTemplateRequest.resultMessage = this.resultMessage;
				this.applyTemplateRequest.savedPaymentMethodToWallet = this.savedPaymentMethodToWallet;
				this.applyTemplateRequest.isEzpay = this.isEzpay;
				break;
			default:
				break;
		}

		this.getTemplate(this.applyTemplateRequest);
	}

	getTemplate(applyTemplateRequest: ApplyTemplateBaseRequest) {
		try {
			this.templateService.applyTemplate(applyTemplateRequest)
				.then((response: ServiceResponse) => {
					if (response.isSuccessful) {
						this.content = this.postReceiptUIControl(response.value);
						this.hasScheduledInReceipt = this.content.includes('Scheduled');
					}
					else {
						console.log(response.resultMessage);
					}
				});
		}
		catch (error) {
			console.log(error);
		}
	}

	postReceiptUIControl(htmlsource: string) {
		let tree = $('<div>' + htmlsource + '</div>');

		if (tree.find('#approveResult').length != 0) {
			tree.find('#approveResult').parent().parent().addClass('success');
		}
		else if (tree.find('#declineResult').length != 0) {
			tree.find('#declineResult').parent().parent().addClass('danger');
		}
		return tree.html();
	}

	doNext() {
		this.clearQueryStringParams();
		this.dispatchCustomEvent('receipt-next');
	}

	clearQueryStringParams() {
		this.payrazrService.queryParameters = {};
	}

	editTransaction() {
		this.editTransactionClickCount++;
		if (this.editTransactionClickCount > 3) {
			this.enableEditTransaction = false;
			this.customMessage = this.i18n.i18next.t('portalEditTransactionExceedRetries', { defaultValue: 'You have exceeded your retry attempts for this session.  Please confirm your payment information and try again later.' });
			return;
		}
		this.reset();
		this.dispatchCustomEvent('edit-transaction-call-back');
	}

	print() {
		window.print();
	}

	attached() {
		this.buildTemplateRequestAndCallApplyTemplate();
	}

	dispatchCustomEvent(eventName) {
		let evt = DOM.createCustomEvent(eventName, { bubbles: true, cancelable: true });

		this.element.dispatchEvent(evt);
	}
}
